import React, { useState } from "react";
import { connect } from "react-redux";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import BannerDetails from "./BannerDetails";
import BannerPreview from "./BannerPreview";
import TypeOrientations from "./TypeOrientations";
import BannerGeneratorHelper from "./helper";

function BannerGenerator({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  colorTextButton,
  logoBrand,
  imageBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  const bannerOrientation = banner.orientation;
  return (
    <>
      <hr />
      <div className="pt-2 w-100">
        <p className="alert alert-warning text-center">
          <span>اندازه بنر انتخابی شما</span>
          <span className="px-2">{banner.size.height}</span>
          <span className="px-2">-</span>
          <span className="px-2">{banner.size.width}</span>
          <span>(ارتفاع-عرض)</span>
        </p>
      </div>
      <div className="row py-0">
        <div className="col-12 col-lg-8 pr-0">
          <BannerDetails banner={banner} />
        </div>
        <div
          className={`col-12  ${
            bannerOrientation == TypeOrientations.portrait
              ? "col-lg-4 pl-0"
              : ""
          }`}
        >
          <BannerPreview
            banner={banner}
            title={title}
            description={description}
            titleButton={titleButton}
            colorButton={colorButton}
            colorTextButton={colorTextButton}
            logoBrand={logoBrand}
            imageBrand={imageBrand}
            backgroundColorDetailsArea={backgroundColorDetailsArea}
            borderRadiusButton={borderRadiusButton}
          />
        </div>
      </div>
    </>
  );
}

export default connect(
  BannerGeneratorHelper.getDetailsBanner,
  null
)(BannerGenerator);
